import React from "react";
import Image from "next/image";
import Link from "next/link";

import Button from "../button";

import styles from "./compare-option-item.module.scss";

const optionFields = (option) => [
  {
    name: "Membership Type",
    field: "membershipType"
  },
  {
    name:
      option.optionType === "Event" ? "Ideal Event Size" : "Ideal Team Size",
    field: "roomSize"
  },
  {
    name: "Hours of Access",
    field: "hoursOfAccess"
  },
  {
    name: "Boardroom Credits",
    field: "boardroomCredits"
  },
  {
    name: "Guest Policy",
    field: "guestPolicy"
  },
  {
    name: "Price",
    field: "shortPrice"
  }
];

const CompareOptionItem = React.forwardRef(function CompareOptionItem(
  { option },
  ref
) {
  return (
    <div className={styles.CompareOptionItem}>
      <div className={styles.OptionContainer} ref={ref}>
        <div className={styles.OptionImageContainer}>
          <div className={styles.OptionImage}>
            <Image
              src={`${option.image.url}?w=289&fm=webp&q=80`}
              width="289"
              height="289"
              layout="responsive"
              alt={option.image.description}
            />
          </div>
        </div>

        <div className={styles.OptionHeader}>
          <h3>{option.name}</h3>

          <p>{option.subtitle}</p>
        </div>

        {optionFields(option)
          .filter((optionField) => option[optionField.field])
          .map((optionField) => (
            <div className={styles.OptionData} key={optionField.field}>
              <div className={styles.OptionDataName}>{optionField.name}</div>
              <div className={styles.OptionDataValue}>
                {option[optionField.field]}
              </div>
            </div>
          ))}
      </div>
      <div className="text-center md:text-left">
        <Link href={`/options/${option.slug}`} passHref>
          <Button outline rounded small>
            View {option.name}
          </Button>
        </Link>
      </div>
    </div>
  );
});

export default CompareOptionItem;
